import { UserStore } from '../state/UserStore'
import { authAPI, ecomAPI, wpapi } from './Axios'

export const UserAPI = {
    login(data) {
        return authAPI.post('auth', data)
    },

    checklogin(jwt) {
        return authAPI.get(`auth/validate&JWT=${jwt}`)
    },

    logout(jwt) {
        return authAPI.post(`auth/revoke&JWT=${jwt}`)
    },

    forgotPass({ email }) {
        return authAPI.post(`user/reset_password&email=${email}`)
    },

    createUser(data) {
        data = new URLSearchParams(Object.entries(data)).toString()
        return authAPI.post(
            `users&${data}&AUTH_KEY=${process.env.AUTH_KEY_VALUE}`,
        )
    },

    resetPass({ email, code, new_password }) {
        return authAPI.put(
            `user/reset_password&email=${email}&code=${code}&new_password=${new_password}`,
        )
    },

    async getUser(id) {
        return await wpapi.users().id(id).get()
    },

    async getStoreCredits() {
        const user = UserStore.getState().user
        if (!user?.user_email) return []
        const payload = {
            user_email: user.user_email,
        }
        const { data } = await ecomAPI.post('?url=getUserCoupons', payload)
        return data
    },

    tryRefresh(jwt) {
        return authAPI.post(`auth/refresh&JWT=${jwt}`)
    },
}
